<template>
  <section class="monitorlist">
    <van-search v-model="MonitorName" show-action label="设备名称" placeholder="请输入搜索关键词" @search="onSearch">
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>

    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="monitordetail" :class="getStatusClass(item.Status)" v-for="item in list">
        <div class="title">{{ item.MonitorName }}</div>
        <p>
          温度：({{ item.T_Low }}-{{ item.T_High }})&nbsp;&nbsp;{{
          item.Channel1
          }}℃
          <br />
          湿度：({{ item.H_Low }}-{{ item.H_High }})&nbsp;&nbsp;{{
          item.Channel2
          }}%
          <br />
          日期：{{ item.UpdateTime | dateFormat }}
          <br />
          时间：{{ item.UpdateTime | TimeFormat }}
        </p>
        <a @click="OnDetailClick(item.MonitorID)">查看</a>
      </div>
    </van-list>
  </section>
</template>
<script>
import mixin from 'js/mixin'
import { BzAjax, BzJs, BzUser, BzMsg } from '@/modules/js/helper'

export default {
  data() {
    return {
      MonitorStats: 0,
      list: [],
      loading: false,
      finished: false,
      pageNo: 0,
      pageSize: 12,
      AreaID: 0,
      StoreID: 0,
      ClientType: 0,
      Status: 0,
      MonitorName: '',
    }
  },
  created() {
    this.StoreID = this.$route.params.StoreID
    this.AreaID = this.$route.params.AreaID
    this.Status = this.$route.params.Status
    // this.getlist()
  },
  methods: {
    getStatusClass(Status) {
      switch (Status) {
        case 2:
          return 'state_Repair'
        case 5:
          return 'state_overproof'
        case 3:
          return 'state_off_line'
        case 4:
          return 'state_No_upload'
        default:
          return 'state_normal'
      }
    },
    OnDetailClick(MonitorID) {
      this.$router.push('/monitordetail/' + MonitorID)
    },
    onLoad() {
      this.pageNo++
      this.getlist()
    },
    onSearch() {
      this.pageNo = 1
      this.list = []
      this.getlist()
    },
    getlist: function () {
      var json = {}
      json.PageNo = this.pageNo
      json.PageSize = this.pageSize
      json.AreaID = this.AreaID
      json.Status = this.Status
      json.RStoreID = this.StoreID
      json.MonitorName = this.MonitorName

      BzAjax.post('/WSD/Monitor/MonitorMessage', json).then((data) => {
        // this.list = data["Table"];
        this.totalCount = data['Table1'][0].Total

        if (this.list.length == 0) this.list = data['Table']
        else {
          data['Table'].forEach((element) => {
            this.list.push(element)
          })
        }

        // 加载状态结束
        this.loading = false
        console.log(this.loading)
        // 数据全部加载完成
        if (data['Table'].length == 0) {
          this.finished = true
        }
      })
    },
  },
  mixins: [mixin],
}
</script>
<style lang="less">
.monitorlist {
  .monitordetail {
    margin: 0.5rem;

    padding: 0 0 1.5rem 0;
    .title {
      padding: 1rem 1rem 0 1rem;
      text-align: center;
      font-weight: 1000;
      font-size: 1.2rem;
    }
    p {
      padding: 1rem 1rem 1rem 2.7rem;
      margin: 0;
      font-size: 1.2rem;
    }
    a {
      display: block;
      width: 7rem;
      height: 2rem;
      border-radius: 1rem;
      color: #fff;
      text-align: center;
      line-height: 2rem;
      margin: auto;
    }
  }
  .state_normal {
    border: 1px solid #0099c6;
    color: #0099c6;
    a {
      background: #0099c6;
    }
  }
  .state_Repair {
    border: 1px solid #68549b;
    color: #68549b;
    a {
      background: #68549b;
    }
  }
  .state_overproof {
    border: 1px solid #dc3912;
    color: #dc3912;
    a {
      background: #dc3912;
    }
  }
  .state_off_line {
    border: 1px solid #999999;
    color: #999999;
    a {
      background: #999999;
    }
  }
  .state_No_upload {
    border: 1px solid #ff9900;
    color: #ff9900;
    a {
      background: #ff9900;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/MonitorList.vue